import { Link } from "react-router-dom";
import { Mail, Instagram, Facebook } from "lucide-react";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-[#0a0a0f] border-t border-purple-500/10">
      <div className="max-w-screen-xl mx-auto px-6 md:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <img 
                src="/nerbys-logo.png" 
                alt="Nerbys Logo" 
                className="w-10 h-10 rounded-xl"
              />
              <span className="font-extrabold text-xl text-white">
                Nerbys
              </span>
            </Link>
            <p className="text-sm text-purple-200/50 leading-relaxed mb-4">
              Connection starts nearby.<br />
              Scopri e connettiti con persone nelle tue vicinanze.
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-10 h-10 bg-purple-500/10 rounded-full flex items-center justify-center text-purple-400 hover:bg-purple-500/20 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-purple-500/10 rounded-full flex items-center justify-center text-purple-400 hover:bg-purple-500/20 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="font-semibold text-sm text-purple-300 mb-4">
              Legale
            </h4>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/privacy" 
                  data-testid="footer-privacy-link"
                  className="text-purple-200/50 hover:text-purple-300 transition-colors text-sm"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link 
                  to="/terms" 
                  data-testid="footer-terms-link"
                  className="text-purple-200/50 hover:text-purple-300 transition-colors text-sm"
                >
                  Termini di Servizio
                </Link>
              </li>
              <li>
                <Link 
                  to="/community" 
                  data-testid="footer-community-link"
                  className="text-purple-200/50 hover:text-purple-300 transition-colors text-sm"
                >
                  Community Guidelines
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-semibold text-sm text-purple-300 mb-4">
              Supporto
            </h4>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/support" 
                  data-testid="footer-support-link"
                  className="text-purple-200/50 hover:text-purple-300 transition-colors text-sm"
                >
                  Centro Assistenza
                </Link>
              </li>
              <li>
                <a 
                  href="mailto:support@nerbys.app"
                  className="text-purple-200/50 hover:text-purple-300 transition-colors text-sm"
                >
                  Contattaci
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-sm text-purple-300 mb-4">
              Contatti
            </h4>
            <a 
              href="mailto:support@nerbys.app"
              data-testid="footer-email"
              className="flex items-center gap-2 text-purple-200/50 hover:text-purple-300 transition-colors text-sm"
            >
              <Mail className="w-4 h-4" />
              support@nerbys.app
            </a>
            <a 
              href="mailto:privacy@nerbys.app"
              className="flex items-center gap-2 text-purple-200/50 hover:text-purple-300 transition-colors text-sm mt-2"
            >
              <Mail className="w-4 h-4" />
              privacy@nerbys.app
            </a>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-purple-500/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-purple-200/40">
            © {currentYear} Nerbys di Giuseppe D'Ambra. Tutti i diritti riservati.
          </p>
          <p className="text-xs text-purple-200/40">
            Versione 1.0.0 • Età 17+
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
